import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/data/site";

const links = [
  { id: "servicios", key: "services" },
  { id: "nosotros", key: "about" },
  { id: "galeria", key: "gallery" },
  { id: "testimonios", key: "testimonials" },
  { id: "faq", key: "faq" },
  { id: "contacto", key: "contact" },
];

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 pt-16 pb-8"
    >
      <div className="container-x grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-1">
          <img
            src={CONTACT.logo}
            alt="Angel Cars Upholstery Service"
            className="h-12 w-auto rounded-md"
          />
          <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-xs">
            {f.tagline}
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-wider">
            {f.quickLinks}
          </h4>
          <ul className="mt-4 space-y-2.5">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-nav-${l.key}`}
                  onClick={() => go(l.id)}
                  className="text-sm text-zinc-400 hover:text-brand transition-colors"
                >
                  {t.nav[l.key]}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-wider">
            {f.contact}
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-zinc-400">
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 text-brand mt-0.5 shrink-0" />
              Florida · Miami-Dade · Broward
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-brand shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-brand break-all">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-brand shrink-0" />
              <a href={`tel:+${CONTACT.phone1Raw}`} className="hover:text-brand">
                {CONTACT.phone1}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-brand shrink-0" />
              <a href={`tel:+${CONTACT.phone2Raw}`} className="hover:text-brand">
                {CONTACT.phone2}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-wider">
            {f.follow}
          </h4>
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2.5 text-sm text-white hover:border-brand hover:text-brand transition-colors"
          >
            <Instagram className="h-4 w-4" />
            {CONTACT.instagramHandle}
          </a>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-zinc-500">
          © {new Date().getFullYear()} {CONTACT.name}. {f.rights}
        </p>
        <p className="text-xs text-zinc-600">Miami-Dade · Broward County, FL</p>
      </div>
    </footer>
  );
};
